import { PIPELINE_ACCORDION_TABLE } from './accordion-table.pipeline';
import { TAccordion, TAccordionOptions, TAccordionTableVM, THeaderInfo } from './accordion-table.types';

export const ACCORDION_TABLE_MODIFIER = {
  createModel(headers: THeaderInfo[], accordions: TAccordion[], options?: TAccordionOptions): TAccordionTableVM {
    return PIPELINE_ACCORDION_TABLE.applyOptions({
      headers: headers,
      accordions: accordions,
      options: options,
    });
  },

  selectAccordionByIndex(accordionModel: TAccordionTableVM, index: number): TAccordionTableVM {
    const { accordions } = accordionModel;
    const isMultiSelect = !!accordionModel.options?.select?.isMulti;
    return PIPELINE_ACCORDION_TABLE.updateAllSelectCells({
      ...accordionModel,
      accordions: accordions.map((accordion, accIndex) => {
        if (accordion.accordionSelectionInfo?.isDisabled) return accordion;
        const hasSameIndex = index === accIndex;
        let isSelected = false;
        if (isMultiSelect) {
          isSelected = hasSameIndex
            ? !accordion.accordionSelectionInfo?.isSelected
            : !!accordion.accordionSelectionInfo?.isSelected;
        } else {
          isSelected = hasSameIndex ? !accordion.accordionSelectionInfo?.isSelected : false;
        }
        return {
          ...accordion,
          accordionSelectionInfo: {
            ...accordion.accordionSelectionInfo,
            isSelected,
            isDisabled: accordion.accordionSelectionInfo?.isDisabled ?? false,
          },
        };
      }),
    });
  },

  selectAllAccordions(accordionModel: TAccordionTableVM): TAccordionTableVM {
    const { options, accordions } = accordionModel;
    const isMultiSelect = !!accordionModel.options?.select?.isMulti;
    const isAllChecked = !!options?.select?.selectAllChecked;
    return PIPELINE_ACCORDION_TABLE.updateAllSelectCells({
      ...accordionModel,
      accordions: accordions.map((accordion) => {
        if (accordion.accordionSelectionInfo?.disabledReason) return accordion;
        return {
          ...accordion,
          accordionSelectionInfo: {
            ...accordion.accordionSelectionInfo,
            isSelected: isMultiSelect ? !isAllChecked : false,
            isDisabled: accordion.accordionSelectionInfo?.isDisabled ?? false,
          },
        };
      }),
    });
  },

  deselectAllAccordions(accordionModel: TAccordionTableVM): TAccordionTableVM {
    return PIPELINE_ACCORDION_TABLE.updateAllSelectCells({
      ...accordionModel,
      accordions: accordionModel.accordions.map((accordion) => {
        if (accordion.accordionSelectionInfo?.disabledReason) return accordion;
        return {
          ...accordion,
          accordionSelectionInfo: {
            ...accordion.accordionSelectionInfo,
            isSelected: false,
            isDisabled: accordion.accordionSelectionInfo?.isDisabled ?? false,
          },
        };
      }),
    });
  },

  toggleRow(
    accordionTableVM: TAccordionTableVM,
    rowId: TAccordionTableVM['accordions'][number]['id'],
  ): TAccordionTableVM {
    return {
      ...accordionTableVM,
      accordions: accordionTableVM.accordions.map((row) => {
        return {
          ...row,
          isMinimized: row.id === rowId ? !row.isMinimized : row.isMinimized,
        };
      }),
    };
  },

  deleteRow(
    accordionTableVM: TAccordionTableVM,
    rowId: TAccordionTableVM['accordions'][number]['id'],
  ): TAccordionTableVM {
    return {
      ...accordionTableVM,
      accordions: accordionTableVM.accordions.filter((row) => row.id !== rowId),
    };
  },
};
